import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=3a5d43d5&scoped=true"
import script from "./Location.vue?vue&type=script&lang=ts"
export * from "./Location.vue?vue&type=script&lang=ts"
import style0 from "./Location.vue?vue&type=style&index=0&id=3a5d43d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d43d5",
  null
  
)

export default component.exports